"use client";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function IC_EN_04({ width, height }) {
  const { theme } = useTheme();
  const [color, setColor] = useState("#324ba6");

  useEffect(() => {
    setColor(theme === "dark" ? "#324BA6" : "#324ba6");
  }, [theme]);
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
    >
      <defs>
        <style>
          {`.cls-1 {
        stroke-width: 0px;
        fill: ${color};
      }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m25.71,23.98c-.15,0-.3-.08-.39-.22-.04-.07-.13-.24-.05-.44h0c.11-.28.37-.3.44-.3s.33.02.44.29h0c.09.21,0,.38-.05.45-.09.14-.24.22-.39.22h-.02Z"
      />
      <path
        className="cls-1"
        d="m4.27,23.98c-.15,0-.3-.08-.39-.22-.04-.07-.13-.24-.05-.44h0c.11-.28.37-.3.44-.3s.33.02.44.29h0c.09.21,0,.38-.05.45-.09.14-.24.22-.39.22h-.02Z"
      />
      <path
        className="cls-1"
        d="m25.71,6.99c-.15,0-.3-.08-.39-.22-.04-.07-.13-.24-.05-.44h0c.11-.28.37-.3.44-.3s.33.02.44.29h0c.09.21,0,.38-.05.45-.09.14-.24.22-.39.22h-.02Z"
      />
      <path
        className="cls-1"
        d="m4.27,6.99c-.15,0-.3-.08-.39-.22-.04-.07-.13-.24-.05-.44h0c.11-.28.37-.3.44-.3s.33.02.44.29h0c.09.21,0,.38-.05.45-.09.14-.24.22-.39.22h-.02Z"
      />
      <path
        className="cls-1"
        d="m.48,27.57c-.27,0-.48-.22-.48-.48V2.91c0-.27.22-.48.48-.48h29.04c.27,0,.48.22.48.48v24.17c0,.27-.22.48-.48.48H.48Zm.48-.96h28.07V3.4H.96v23.21Z"
      />
      <path
        className="cls-1"
        d="m18.43,14.71c-.27,0-.48-.22-.48-.48v-1.98c0-.27.22-.48.48-.48s.48.22.48.48v1.98c0,.27-.22.48-.48.48Z"
      />
      <path
        className="cls-1"
        d="m11.57,14.71c-.27,0-.48-.22-.48-.48v-1.92c0-.27.22-.48.48-.48s.48.22.48.48v1.92c0,.27-.22.48-.48.48Z"
      />
      <path
        className="cls-1"
        d="m15.01,23.06c-1.2,0-2.33-.46-3.19-1.3-.86-.84-1.35-1.95-1.39-3.15v-.41h-1.11c-1.24,0-2.26-1.01-2.26-2.26v-5.47c0-1.24,1.01-2.26,2.26-2.26h11.35c1.24,0,2.26,1.01,2.26,2.26v5.47c0,1.24-1.01,2.26-2.26,2.26h-1.07v.41c-.05,1.19-.54,2.31-1.4,3.15-.86.84-2,1.3-3.19,1.3Zm-5.69-13.88c-.71,0-1.29.58-1.29,1.29v5.47c0,.71.58,1.29,1.29,1.29h1.59c.27,0,.48.22.48.48v.76c0,2,1.62,3.62,3.62,3.62s3.62-1.62,3.62-3.62v-.76c0-.27.22-.48.48-.48h1.56c.71,0,1.29-.58,1.29-1.29v-5.47c0-.71-.58-1.29-1.29-1.29h-11.35Z"
      />
      <path
        className="cls-1"
        d="m15,19.49c-.27,0-.48-.22-.48-.48v-.6c0-.27.22-.48.48-.48s.48.22.48.48v.6c0,.27-.22.48-.48.48Z"
      />
    </svg>
  );
}
